import {
  RequirementConditionOperator,
  RequirementConditionType
} from 'generated-graphql/types';
import { AutomationFormItem } from '../types/AutomationFormItem';

export const getDefaultRequirementCondition = (
  requirementConditionType: RequirementConditionType
): AutomationFormItem['requirementConditions'] => {
  return requirementConditionType === RequirementConditionType.ConversationScore
    ? [
        {
          type: RequirementConditionType.ConversationMandatoryQuestionsMet,
          operator: RequirementConditionOperator.IsTrue
        },
        {
          type: RequirementConditionType.ConversationScore,
          operator: RequirementConditionOperator.EqualToOrGreaterThan,
          preferredAnswerScore: 0.7
        }
      ]
    : [
        {
          type: RequirementConditionType.CandidateRequirementsMetCondition,
          operator: RequirementConditionOperator.IsTrue
        },
        {
          type: RequirementConditionType.CandidateScoreCondition,
          operator: RequirementConditionOperator.EqualToOrGreaterThan,
          scoreScaled: 0.7
        }
      ];
};
